module.exports = __webpack_public_path__ + "static/img/qcjg4.47f4fa3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qcjg4.png
// module id = 9k8r
// module chunks = 1